import React from 'react';

import { CardResizerService } from '~src/spacesPlatform/services/CardResizerService';

export function useCardZoomPercentage() {
    const [cardZoomPercentage, setCardZoomPercentage] = React.useState(CardResizerService.instance.getCardZoomPercentage());
    React.useEffect(() => {
        const unsubscribe = CardResizerService.instance.registerListener(value => {
            setCardZoomPercentage(value);
        });

        return unsubscribe;
    }, []);

    return cardZoomPercentage || 1.0;
}